import { message } from 'antd';
import { isNotEmpty, parseUrlSearch } from './Utils';

class UIFetchService {

    async post(url, req) { return this.method("POST", url, req); }

    async put(url, req) { return this.method("PUT", url, req); }

    async delete(url) { return this.method("DELETE", url, {}); }

    async method(way, url, req) {
        try {
            const params = parseUrlSearch(window.location.search);
            const headers = {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            };
            if (isNotEmpty(params.access_token)) {
                headers['Cya-Datap-AK'] = params.access_token;
            }
            let response = await fetch(url, {
                method: way,
                body: req === undefined || req === null ? null : JSON.stringify(req),
                headers
            });
            this.handleError(response);
            if (response.headers.get('content-length') === '0' ||
                response.status !== 200) {
                return;
            }
            return await response.json();
        } catch (error) {
            console.error(way, url, error);
            throw error;
        }
    }

    async get(url) {
        try {
            const params = parseUrlSearch(window.location.search);
            const headers = {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            };
            if (isNotEmpty(params.access_token)) {
                headers['Cya-Datap-AK'] = params.access_token;
            }
            let response = await fetch(url, {
                method: 'GET',
                headers
            });
            this.handleError(response);
            if (response.headers.get('content-length') === '0' ||
                response.status !== 200) {
                return;
            }
            return await response.json();
        } catch (error) {
            console.error('GET', url, error);
            throw error;
        }
    }

    handleError(response) {
        delete this.latestError;
        if (response.status === 401) {
            window.location.assign(`https://cyamis.baicizhan.com/home/scan_to_login_weixin?redirect=${encodeURI(window.location)}`);
        } else if (response.status === 403) {
            message.error('没有权限访问此内容。');
        } else if (response.status === 500) {
            response.json().then((json) => {
                if (json && json.message) {
                    message.error('服务端错误：' + json.message);
                    this.latestError = json.message;
                } else {
                    message.error('服务器内部故障，请联系开发人员。');
                }
            })
        } else if (response.status === 502) {
            message.error('服务器发布中，请稍后再试。');
        } else if (response.status === 200) {
            // OK!
        } else {
            message.error('服务错误：' + response.status);
        }
    }
}

export default new UIFetchService();